import React, { useMemo, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5002";

const ResetPasswordDriver = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const email = useMemo(() => searchParams.get("email") || "", [searchParams]);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!token || !email) {
      setError("Lien invalide ou incomplet.");
      return;
    }

    if (!password || !confirmPassword) {
      setError("Tous les champs sont obligatoires.");
      return;
    }

    if (password.length < 8) {
      setError("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${API}/api/auth/reset-password-driver/${token}`,
        {
          email,
          password,
        }
      );

      setMessage(res.data?.message || "Mot de passe chauffeur réinitialisé.");
      setPassword("");
      setConfirmPassword("");

      setTimeout(() => {
        navigate("/");
      }, 1800);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Impossible de réinitialiser le mot de passe chauffeur."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Réinitialisation mot de passe chauffeur</h1>
        <p style={styles.subtitle}>
          Définis un nouveau mot de passe pour ton compte chauffeur.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" value={email} disabled />

          <label style={styles.label}>Nouveau mot de passe</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Nouveau mot de passe"
          />

          <label style={styles.label}>Confirmer le mot de passe</label>
          <input
            style={styles.input}
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirme le mot de passe"
          />

          {error ? <div style={styles.error}>{error}</div> : null}
          {message ? <div style={styles.success}>{message}</div> : null}

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Réinitialisation..." : "Réinitialiser"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0b0b0f",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "460px",
    background: "#13131a",
    border: "1px solid rgba(212,175,55,0.18)",
    borderRadius: "18px",
    padding: "28px",
    color: "#fff",
    boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
  },
  title: {
    margin: 0,
    marginBottom: "10px",
    color: "#d4af37",
  },
  subtitle: {
    marginTop: 0,
    marginBottom: "20px",
    color: "#bbb",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  label: {
    fontWeight: 600,
    color: "#ddd",
  },
  input: {
    background: "#0f1116",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "12px",
    padding: "12px 14px",
    color: "#fff",
    outline: "none",
  },
  button: {
    marginTop: "8px",
    background: "#d4af37",
    color: "#111",
    border: "none",
    borderRadius: "12px",
    padding: "13px 16px",
    fontWeight: 700,
    cursor: "pointer",
  },
  error: {
    background: "rgba(255,77,79,0.10)",
    border: "1px solid rgba(255,77,79,0.25)",
    color: "#ff6b6b",
    padding: "10px 12px",
    borderRadius: "10px",
  },
  success: {
    background: "rgba(31,174,91,0.10)",
    border: "1px solid rgba(31,174,91,0.25)",
    color: "#7ee2a8",
    padding: "10px 12px",
    borderRadius: "10px",
  },
};

export default ResetPasswordDriver;